import React from "react";
import { useState, useContext, useEffect } from "react";

import {
  Grid,
  TextField,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  InputAdornment,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  FormHelperText,
  IconButton,
} from "@material-ui/core";
import CheckCircleRoundedIcon from "@material-ui/icons/CheckCircleRounded";
import EditIcon from "@material-ui/icons/Edit";

//Styles
import useStyles from "./styles";

//Context
import { SectoresContext } from "../../views/sectores/context";
import { APIContext } from "../../../context";

//hook
import useFormValidation from "../../../hooks/formValidation";
import validateSectorForm from "./validations";
import validateSectorFormUpdate from "./validations2";

const SectorDialogForm = ({ dialogOpen, handleClose, array, edit }) => {
  const classes = useStyles();

  // Vehiculo Context
  const { form, estado } = useContext(SectoresContext);

  //APIContext
  const { sectores, createSector, listSectores, updateSector } =
    useContext(APIContext);

  const funct = edit ? updateSector : createSector;
  const validation = edit ? validateSectorFormUpdate : validateSectorForm;
  if (!edit) {
    form["sect_estado"] = 1;
  }
  // Validation Hook
  const {
    fields,
    setFields,
    errors,
    handleSubmit,
    handleChange,
    handleBlur,
    clearFields,
    clearErrors,
    readyToSubmit,
  } = useFormValidation(form, validation, funct, handleClose);

  const [clearer, setClearer] = useState(null);
  const [updatedFields, setUpdatedFields] = useState([]);
  const [active, setactive] = useState(null);

  const [enabledFields, setEnabledFields] = useState({
    sect_nombre: true,
    sect_estado: true,
  });

  useEffect(() => {
    if (sectores.length === 0) {
      listSectores();
    }
  }, []);

  useEffect(() => {
    if (edit && array[0]) {
      setFields(array[0]);
    }
  }, [array]);

  useEffect(() => {
    if (clearer === true) {
      clearFields();
      clearErrors();
      setClearer(false);
    }
  }, [clearer, errors]);

  const cleanEnabledFields = () => {
    setEnabledFields({
      sect_nombre: true,
      sect_estado: true,
    });
  };
  return (
    <>
      <Dialog
        open={dialogOpen}
        onClose={() => {
          handleClose();
          setClearer(true);
          cleanEnabledFields();
        }}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        maxWidth={"md"}
        fullWidth={true}
      >
        <DialogTitle id="alert-dialog-aprobar-causa-title">
          <Grid container spacing={3} justifyContent="space-between">
            <Grid item xs={12} md={9} lg={9}>
              {edit ? `Sector ${fields.sect_nombre}` : "Crear nuevo registro"}
            </Grid>
          </Grid>
        </DialogTitle>

        <DialogContent dividers>
          <div className={classes.root}>
            <Grid container spacing={3} justifyContent="space-between">
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  id="sect_nombre"
                  name="sect_nombre"
                  label="Nombre"
                  value={fields.sect_nombre || ""}
                  onChange={(e) => {
                    handleChange(e);
                    if (!updatedFields.includes("sect_nombre")) {
                      setUpdatedFields([...updatedFields, "sect_nombre"]);
                    }
                  }}
                  onBlur={(e) => {
                    handleBlur(e);
                    cleanEnabledFields();
                  }}
                  autoFocus
                  error={"sect_nombre" in errors}
                  helperText={
                    "sect_nombre" in errors
                      ? errors.sect_nombre
                      : "Nombre del sector económico"
                  }
                  onMouseOver={() => {
                    setactive("sect_nombre");
                  }}
                  onMouseLeave={() => {
                    setactive(null);
                  }}
                  InputProps={{
                    readOnly: enabledFields.sect_nombre && edit,
                    endAdornment: (
                      <>
                        {active === "sect_nombre" && edit && (
                          <InputAdornment position="start">
                            <IconButton
                              aria-label="edit"
                              className={classes.margin}
                              onClick={() => {
                                setEnabledFields({
                                  ...enabledFields,
                                  sect_nombre: false,
                                });
                                document.getElementById("sect_nombre").focus();
                              }}
                            >
                              <EditIcon fontSize="small" />
                            </IconButton>
                          </InputAdornment>
                        )}
                      </>
                    ),
                  }}
                />
              </Grid>

              <Grid item xs={6} sm={6}>
                <FormControl
                  className={classes.formControl}
                  error={"sect_estado" in errors}
                >
                  <InputLabel id="select-label">Estado</InputLabel>
                  <Select
                    autoWidth
                    labelId="select-label"
                    id="sect_estado"
                    name="sect_estado"
                    value={fields.sect_estado ? fields.sect_estado : ""}
                    onChange={(e) => {
                      handleChange(e);
                      if (!updatedFields.includes("sect_estado")) {
                        setUpdatedFields([...updatedFields, "sect_estado"]);
                      }
                    }}
                    onBlur={(e) => {
                      handleBlur(e);
                      cleanEnabledFields();
                    }}
                    onMouseOver={() => {
                      setactive("sect_estado");
                    }}
                    onMouseLeave={() => {
                      setactive(null);
                    }}
                    readOnly={enabledFields.cli_tipide && edit}
                    endAdornment={
                      <>
                        {active === "sect_estado" && edit && (
                          <InputAdornment position="start">
                            <IconButton
                              aria-label="edit"
                              className={classes.margin}
                              onClick={() => {
                                setEnabledFields({
                                  ...enabledFields,
                                  sect_estado: false,
                                });
                                document.getElementById("sect_estado").focus();
                              }}
                            >
                              <EditIcon fontSize="small" />
                            </IconButton>
                          </InputAdornment>
                        )}
                      </>
                    }
                  >
                    {estado.map((estado) => (
                      <MenuItem
                        key={estado.tipo + estado.value}
                        value={estado.value}
                      >
                        {estado.tipo}
                      </MenuItem>
                    ))}
                  </Select>
                  <FormHelperText>
                    {"sect_estado" in errors
                      ? errors.sect_estado
                      : "Seleccione el estado"}
                  </FormHelperText>
                </FormControl>
              </Grid>
            </Grid>
          </div>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              handleClose();
              setClearer(true);
              cleanEnabledFields();
            }}
            color="secondary"
          >
            Cancelar
          </Button>
          {edit ? (
            <Button
              //type="submit"
              variant="contained"
              color="primary"
              disabled={!readyToSubmit}
              onClick={(e) => {
                handleSubmit(e);
                handleClose();
                setClearer(true);
                cleanEnabledFields();
              }}
            >
              <CheckCircleRoundedIcon />
              Guardar Cambios
            </Button>
          ) : (
            <Button
              //type="submit"
              variant="contained"
              color="primary"
              disabled={!readyToSubmit}
              onClick={(e) => {
                handleSubmit(e);
                handleClose();
                setClearer(true);
              }}
            >
              <CheckCircleRoundedIcon />
              Guardar
            </Button>
          )}
        </DialogActions>
      </Dialog>
    </>
  );
};
export default SectorDialogForm;
